import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        nowPiece: {
            "a": [false, false],
            "b": [false, false, false, false],
            "c": [false],
        },
        checkTos: false,
        localUserHashKey: null,
        // checkDevice: false,
        hashPrefix: "chibi",
        isMaintenance: false,
        setting: null,
        shopKey: null,
        urlParamId: null
    },
    getters: {
        nowPiece: state => state.nowPiece,
        dataFrameA: state => state.setting.frame.a,
        dataFrameB: state => state.setting.frame.b,
        dataFrameC: state => state.setting.frame.c,
        setting: state => state.setting,
        dataMaps: state => state.setting.maps,
        isLoad: state => state.localUserHashKey != null,
        isMaintenance: state => state.isMaintenance,
        isCheckTos: state => state.checkTos,
        // checkDevice: state => state.checkDevice,
        localUserHashKey: state => state.localUserHashKey,
        shopKey: (state) => {
            return state.shopKey;
        },
        redirectUrl: (state) => {
            let url = state.setting?.redirect;
            if (url === "") url = undefined;
            return url;
        },
        titleBaseUrl: (state) => {
            return state.setting.top.title.bg;
        },
        bannerData: (state) => {
            return state.setting.top.banner;
        },
        dataHowtoplay1: state => state.setting.howtoplay.page1?state.setting.howtoplay.page1:{"text":"会場内のちびゴジラたちのパネルにあるQRコードをスマートフォンで読みこんでパズルのピースを集めよう！パネルは会場内に散らばってるよ！","image":"/images/howtoplay/htp1.png"},
        dataHowtoplay3: state => state.setting.howtoplay.page3,
        dataHowtoplay4: state => state.setting.howtoplay.page4,
        urlParamId: state => state.urlParamId,
        analyticsGa4: state => state.setting?.analytics?.ga4,
    },
    mutations: {
        init(state, data) {
            console.log("INIT", data);

            if (!data) return;
            state.nowPiece = data.nowPiece;
            state.checkTos = data.checkTos;
            state.localStorageKey = data.localStorageKey;
        },
        setMaintenance(state, data) {
            state.isMaintenance = data;
        },
        // checkDevice(state, data) {
        //     state.checkDevice = data;
        // },
        setTos(state, data) {
            state.checkTos = data;
        },
        setLocalUserHashKey(state, data) {
            state.localUserHashKey = data;
        },
        setSetting(state, data) {
            state.setting = data;
        },
        setPiece(state, data) {
            state.nowPiece[data.frame][data.num] = true;
            // console.log(state.nowPiece)
        },
        setAllPiece(state, data) {
            state.nowPiece = data;
        }
    },
    actions: {
        initParam(ctx) {
            const params = new URLSearchParams(location.search);
            ctx.state.shopKey = params.get("key");
            ctx.state.urlParamId = params.get("id");
        },
    }
})